UserService.$inject = ['$resource', 'StoresService'];

function UserService($resource, StoresService) {
    const roles = $resource('api/roles');
    let _roles;

    this.getRoles = getRoles;
    this.isInStore = isInStore;
    this.isAdmin = isAdmin;
    this.isInRole = isInRole;

    function getRoles() {
        if (!_roles) {
            _roles = roles.query().$promise;
        }
        return _roles;
    }

    function isInStore() {
        return StoresService.getStore().then(store => {
            var key = CryptoJS.enc.Utf8.parse('u001AT%87ub@*%#@');  
            var iv = CryptoJS.enc.Utf8.parse(')~%^2rT^I42&^r11');
            var storeid= CryptoJS.AES.encrypt(String(store.storeId), key, {  
                                    keySize: 128 / 8,  
                                    iv: iv,  
                                    mode: CryptoJS.mode.CBC,  
                                    padding: CryptoJS.pad.Pkcs7  
                                });
            var storenumber=  storeid.toString()  
                // console.log("storeid",storenumber)
            return getRoles().then(r => r.indexOf(String(storenumber)) != -1);
        });
    }

    function isAdmin() {
        return getRoles().then(r => r.indexOf('Admins') != -1);
    }
    
    function isInRole(role) {
        var key = CryptoJS.enc.Utf8.parse('u001AT%87ub@*%#@');  
        var iv = CryptoJS.enc.Utf8.parse(')~%^2rT^I42&^r11');
        var roleid= CryptoJS.AES.encrypt(String(role), key, {  
                                keySize: 128 / 8,  
                                iv: iv,  
                                mode: CryptoJS.mode.CBC,  
                                padding: CryptoJS.pad.Pkcs7  
                            });
            var rolevalue=  roleid.toString();  
            // console.log("role",rolevalue)
        return getRoles().then(r => r.indexOf(rolevalue) != -1);
    }
}

export default UserService;



// WEBPACK FOOTER //
// ./src/js/services/user/index.js